import React, {Component} from 'react';
import {connect} from 'react-redux';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import overlayFactory from 'react-bootstrap-table2-overlay';
import {helpers} from "./../../utils/helpers"
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import _ from "lodash";
import Dropdown from '../base/dropdown';

import api from '../../utils/api';
import Title from '../base/title';
import Cta from '../base/cta';
import Modal from '../base/modal';
import {ToastContainer, toast} from 'react-toastify';
import EmptyRow from "../../components/EmptyRow";
import LoadingSpinner from "../../components/spinner/Spinner";
import {tokenHeader} from "../../utils/headers";
import urls from "../../utils/urls";
import axios from "axios/index";


class Simulacion extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loader: ' loader-box',
            modalVisible: false,
            modalDeletePrice: false,
            modalEditPriceVisible: false,
            data: {},
            fileStatus: '',
            page: 1,
            sortBy: "service_station__global_code",
            tableData: false,
            priceToDelete: 0,
            priceToEdit: 0,
            price: '',
            products: false,
            product: {id: 0, label: "SELECCIONAR"},
            count: 0,
            boca: [{ id: 0, label: "BOCA" }],
            bocaValue:'',
            processedData: {
                details: {
                    general_simulation: {
                        shell: [],
                        pm: []
                    },
                    cluster_simulation_list: []
                }
            },

        }

    }

    componentDidMount() {
        let _self = this;
        let editId = _self.props.editId;

        if (editId) {
            api.get("simulations/id/" + editId).then(out => {
                let data = out.data;
                data.details = JSON.parse(data.details);
                _self.setState({data: data, processedData: data, loader: ''}, this._fetchTableData);
            });
        }

        api.get('filters/products/').then(out => {
            let products = [];
            products.push({id: 0, label: "SELECCIONAR"});
            out.data.forEach((prod) => {
                products.push({label: prod.short_name, id: prod.id})
            });
            this.setState({products});
        });
    }

    _fetchTableData = () => {
        let editId = this.props.editId;

        let url = "reference-prices/?report=" + editId + "&";

        if (this.state.data.status === 'DRAFT') {
            url = "draft-reference-prices/?report=" + editId + "&";
        }

        if (this.state.page && this.state.page > 1) {
            url += `page=${this.state.page}&`;
        }
        if (this.state.sortBy !== '') {
            url += `ordering=${this.state.sortBy}&`;
        }

        if(this.state.product && this.state.product.id){
            url += `product=${this.state.product.id}&`;
        }

        if(this.state.bocaValue!==''){
            url +=`service_station__global_code__icontains=${this.state.bocaValue}`;
        }

        this.setState({xhr: true});
        console.log(url);
        api.get(url).then(out => {
            this.setState({tableData: out.data.results, count: out.data.count, xhr: false});
        });

    };


    _onTableChange = (type, {page, sizePerPage, filters, sortField, sortOrder}) => {
        if (type === 'pagination') {
            this.setState({page}, this._fetchTableData);
        } else if (type === 'sort') {
            this.setState({
                page: 1,
                sortBy: `${sortOrder === 'asc' ? '' : '-'}${sortField}`,
            }, this._fetchTableData);
        }
    };

    _getServiceStationCell = (row) => {
        return `${row.service_station.global_code} - ${row.service_station.company.name} -  ${row.service_station.address}`;
    };

    editColumn = (cell, item) => {
        return (
            <div className={"action-images"}>
                <i style={{marginRight: 10}} className="material-icons shell-red-text"
                   onClick={() => {
                       this.setState({priceToEdit: item, price: item.price}, () => this.refs.modalEditPrice.show());
                   }}
                >edit</i>
                <i className="material-icons shell-red-text" style={{cursor: 'pointer'}}
                   onClick={() => {
                       this.setState({priceToDelete: item.id}, () => this.refs.modalDeletePrice.show());
                   }}
                >delete</i>
            </div>
        )
    };

    _checkState = (reportId) => {
        const simulation_url = `${urls.API_ROOT}/api/v1/simulations/id/${reportId}/`;
        axios
            .get(simulation_url, tokenHeader())
            .then((response) => {
                let fileStatus = response.data.status;
                if (fileStatus === "IN_PROCESS") {
                    setTimeout(() => this._checkState(reportId), 2000);
                }
                if (fileStatus === "INFORMED") {
                    window.location.reload();
                }

            })
            .catch((error) => console.log(error));
    };

    filterProduct = (item) => {
        this.setState({product:item, page:1}, this._fetchTableData);
    };

    autocompleteStation = (search) =>{
        this.setState({bocaValue:search, page:1}, this._fetchTableData);
    };

    render() {
        let _self = this;

        let isDraft = this.state.data.status === "DRAFT";

        let cancel = {
            text: 'CANCELAR',
            click: () => {
                _self.refs.modal.hide();
                _self.refs.modalDeletePrice.hide();
                _self.refs.modalEditPrice.hide();
            }
        };

        let confirm = {
            text: 'CONFIRMAR',
            click: () => {
                api.delete('simulations/id/' + _self.props.editId + '/').then(resp => {
                    _self.props.switchToStep(1);
                    _self.props.setEditId(null);
                })
            }
        };

        let confirmPriceDelete = {
            text: 'CONFIRMAR',
            click: () => {
                api.delete('draft-reference-prices/id/' + this.state.priceToDelete + '/').then(resp => {
                    _self.refs.modalDeletePrice.hide();
                    this._fetchTableData();
                })
            }
        };

        let confirmEditPrice = {
            text: 'CONFIRMAR',
            click: () => {
                if (this.state.price === '') {
                    window.Materialize.toast("El precio es obligatorio", 3000);
                    return false;
                }
                api.put('draft-reference-prices/id/' + this.state.priceToEdit.id + '/', {price: this.state.price}).then(resp => {
                    _self.refs.modalEditPrice.hide();
                    this._fetchTableData();
                })
            }
        };

        let confirmSave = {
            text: 'CONFIRMAR',
            click: () => {
                let _self = this;
                this.setState({fileStatus: "Impactando precios en la herramienta"});
                api.post("create/reference-prices/id/" + _self.state.processedData.id).then(out => {
                    if (out.status === 200) {
                        this._checkState(_self.state.processedData.id)
                    }
                }).catch(e => {
                    toast.error('No se pudo guardar el cluster');
                });
            }
        };

        let columns = helpers.getPricesColumns();

        if (this.state.data && isDraft) {
            columns.push({
                text: '',
                dataField: 'actions',
                formatter: this.editColumn
            });
        }

        const pagination = paginationFactory({
            page: this.state.page,
            sizePerPage: 20,
            totalSize: this.state.count,
            hideSizePerPage: true
        });


        let data = [];
        if (this.state.tableData && this.state.tableData instanceof Array) {
            this.state.tableData.forEach(price => {
                let row = {id: price.id};
                columns.forEach(col => {
                    if (!col.isCustom) {
                        row[col.dataField] = _.get(price, col.path, '-');
                        if (!row[col.dataField] || row[col.dataField] === '') {
                            row[col.dataField] = '-';
                        }
                    } else {
                        switch (col.path) {
                            case 'service_station':
                                row[col.dataField] = this._getServiceStationCell(price);
                                break;
                            default:
                                row[col.dataField] = '-'
                        }
                    }

                });
                data.push(row);
            });
        }

        return (
            <div>
                <Modal ref="modal" visible={_self.state.modalVisible} save={confirm} cancel={cancel}>
                    <p className="red-text">Esta seguro que desea borrar la simulacion?</p>
                </Modal>
                <Modal ref="modalDeletePrice" visible={_self.state.modalDeletePriceVisible} save={confirmPriceDelete}
                       cancel={cancel}>
                    <p className="red-text">Esta seguro que desea borrar el precio?</p>
                </Modal>
                <Modal ref="modalEditPrice" visible={_self.state.modalEditPriceVisible} save={confirmEditPrice}
                       cancel={cancel}>
                    <div className={"modal-text-value"}>
                        <div className="red-text"> Boca:</div>
                        <div className={"text"}>{this.state.priceToEdit.service_station__global_code}</div>
                    </div>
                    <div className={"modal-text-value"}>
                        <div className="red-text "> Producto:</div>
                        <div className={"text"}>{this.state.priceToEdit.product__short_name}</div>
                    </div>
                    <div className={"modal-text-value"}>
                        <div className="red-text"> Precio:</div>
                        <input type="number" placeholder="Precio" value={this.state.price}
                               onChange={ev => _self.setState({price: ev.target.value})}/>
                    </div>
                </Modal>
                <Modal ref="modalSave" visible={_self.state.modalVisible} hideButtons={this.state.fileStatus !== ''}
                       save={confirmSave} cancel={cancel}>
                    {this.state.fileStatus === '' &&
                    <p className="red-text">Estas seguro que deseas guardar la simulacion?</p>}
                    {this.state.fileStatus !== '' &&
                    <div>
                        <p className="red-text">{this.state.fileStatus}</p>
                        <LoadingSpinner width={50}/>
                    </div>

                    }
                </Modal>
                <ToastContainer/>
                <section className="admin">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col s12">
                                <div className="simulador_simulacion_header">
                                    <div className="row vmiddle">
                                        <div className="col s2 no-gutter">
                                            <h2 style={{
                                                textAlign: 'center',
                                                minHeight: 20
                                            }}>{_self.state.processedData.name}</h2>
                                        </div>
                                        <div className="col s6 no-gutter">
                                            <div className="simulador_simulacion_header_box">
                                                <span
                                                    className="simulador_simulacion_header_box_change-type">Carga Masiva</span>
                                            </div>
                                        </div>
                                        <div className={isDraft ? "col s4 no-gutter" : "col s2 no-gutter"}>
                                            <div className="simulador_simulacion_header_box_btns"
                                                 style={{display: 'inline-block'}}>
                                                <button type="button" className="cta cta_trash" onClick={() => {
                                                    _self.refs.modal.show();
                                                }}>
                                                    <i className="far fa-trash-alt"></i>
                                                </button>
                                                {isDraft &&
                                                <div className="simulador_simulacion_header_box_btns footer-btns">
                                                    <Cta click={() => {
                                                        _self.refs.modalSave.show();
                                                    }} text="IMPACTAR EN LA HERRAMIENTA" toolIcon centered
                                                         className="lg red-border"/>
                                                </div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Title text="SIMULAR CARGA MASIVA DE PRECIOS" className=''/>
                        <div className={"col s12 filters"}>
                            <div className="row">
                                {this.state.products &&
                                <div className="col s3 no-gutter">
                                    <Dropdown ref="product" selected={this.state.product}
                                              text='PRODUCTO:   ' items={this.state.products}
                                              getItem={this.filterProduct}/>
                                </div>}
                                <div className="col s2 ">
                                    <Dropdown forceActive ref="dpump" autocomplete={this.autocompleteStation} text=''
                                              items={this.state.boca} noIcon getItem={this.getBocaItem} />
                                </div>
                            </div>
                        </div>
                        <div className={"border"}>

                            <div className={this.state.tableData !== false ? 'main-table' : 'loader-box'}>
                                <BootstrapTable
                                    remote
                                    keyField='id'
                                    bordered={true}
                                    data={data}
                                    columns={columns}
                                    noDataIndication={() => {
                                        return <EmptyRow text={"No hay información disponible"}/>
                                    }}
                                    pagination={pagination}
                                    loading={this.state.xhr}
                                    overlay={overlayFactory({
                                        spinner: true,
                                        background: 'rgba(192,192,192,0.85)',
                                        text: 'Cargando precios...',
                                    })}
                                    onTableChange={this._onTableChange}
                                />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
}

export default connect(mapStateToProps)(Simulacion);



// WEBPACK FOOTER //
// ./src/containers/simulador/cargaMasiva.js